<div #messageContainer class="row-container" [class.align-right]="message?.sender === 'user'">
  <div class="message-container">
    <span class="sender">{{message?.sender === 'user' ? 'Du' : 'KI-Tutor'}}</span>
    <p *ngIf="message && !message!.pending" class="content">
      {{message!.content}}
    </p>
    <div *ngIf="message && message!.pending" class="typing-indicator">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</div>